import { render, staticRenderFns } from "./StkInventoryModal.vue?vue&type=template&id=38fc1814&scoped=true&"
import script from "./StkInventoryModal.vue?vue&type=script&lang=js&"
export * from "./StkInventoryModal.vue?vue&type=script&lang=js&"
import style0 from "./StkInventoryModal.vue?vue&type=style&index=0&id=38fc1814&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc1814",
  null
  
)

export default component.exports